module.exports = __webpack_public_path__ + "img/icon-5.4817278b.png";